<template>
  <div class="min-h-screen bg-[#0f172a] overflow-x-hidden">

      <button
      type="button"
      data-mdb-ripple="true"
      data-mdb-ripple-color="light"
      @click="backToTop"
      class="inline-block z-10 p-3 hover:scale-105 transition-all  bg-yellow-400 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover: bg-yellow-400 hover:shadow-lg focus: bg-yellow-400  focus:shadow-lg focus:outline-none focus:ring-0 active: bg-yellow-400  active:shadow-lg transition duration-150 ease-in-out bottom-5 right-5"
      id="btn-back-to-top"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        class="w-4 h-4"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill="currentColor"
          d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ></path>
      </svg>
    </button>


       <!-- ================= NAVBAR ================= -->
    <Popover
      :class="[
        'fixed w-full top-0 left-0 z-50 transition-all duration-300',
        scrolled
          ? 'bg-[#0f172a] backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      ]"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between py-4">

          <!-- Logo -->
          <router-link to="/" class="flex items-center gap-2">
            <img class="h-9 w-auto" src="../assets/logo11.png" alt="oillead" />
            <div class="leading-tight">
              <div class="text-sm font-extrabold text-white">
                OIL<span class="text-yellow-400">L</span>EAD
              </div>
              <div class="text-xs font-bold tracking-wide text-yellow-400">
                SERVICES
              </div>
            </div>
          </router-link>

          <!-- Desktop Nav -->
          <PopoverGroup class="hidden lg:flex items-center gap-10">
            <router-link to="/" class="nav-link">HOME</router-link>
            <router-link to="/about" class="nav-link">ABOUT US</router-link>
            <router-link to="/services"  class="nav-link">SERVICES</router-link>
            <router-link to="/projects"  class="nav-link">PROJECTS</router-link>
            <router-link to="/contact"  class="nav-link">CONTACT US</router-link>
          </PopoverGroup>

          <!-- Mobile Button -->
          <div class="lg:hidden">
            <PopoverButton
              class="rounded-md p-2 text-white hover:bg-white/10 transition"
            >
              ☰
            </PopoverButton>
          </div>
        </div>
      </div>

      <!-- ================= MOBILE MENU ================= -->
      <transition
        enter-active-class="duration-200 ease-out"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-150 ease-in"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <PopoverPanel
          v-slot="{ close }"
          focus
          class="absolute z-50 top-0 inset-x-0 p-4 transform origin-top-right lg:hidden"
        >
          <div class="rounded-2xl shadow-2xl
                      bg-[#0f172a]/95 backdrop-blur-xl
                      border border-white/10">

            <div class="flex items-center justify-between px-6 py-5 border-b border-white/10">


                <div class="text-sm flex gap-2 font-bold text-white" >
                  <PopoverButton
                    class="flex items-center outline-none ring-0 focus:outline-none focus:ring-0 active:ring-0 border-0"
                    >
                    <img class="h-8 w-auto sm:h-10" src="../assets/logo11.png" alt="" />
                    </PopoverButton>
                   <div class="leading-tight">
                        <div class="text-sm font-extrabold text-white">
                            OIL<span class="text-yellow-400">L</span>EAD
                        </div>
                        <div class="text-xs font-bold tracking-wide text-yellow-400">
                            SERVICES
                        </div>
                    </div>
                </div>


              

              <PopoverButton
                class="rounded-md p-2 text-white hover:bg-white/10 transition"
              >
                ✕
              </PopoverButton>
            </div>

             <div class="px-6 py-6 flex flex-col items-center text-center gap-6">
                <router-link to="/homepage" class="nav-link" @click="close">HOME</router-link>
                <router-link to="/about" class="nav-link" @click="close">ABOUT US</router-link>
                <router-link to="/services" class="nav-link" @click="close">SERVICES</router-link>
                <router-link to="/projects" class="nav-link" @click="close">PROJECTS</router-link>
                <router-link to="/contact" class="nav-link" @click="close">CONTACT US</router-link>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>

    <!-- ================= HERO ================= -->
    <section
      id="home"
      class="relative isolate overflow-hidden py-32 pt-40 bg-gradient-to-b from-slate-950 to-slate-900"
    >
     <!--
    <div class="absolute inset-0 -z-10 opacity-20">
        <div class="absolute -top-40 right-0 blur-3xl w-[70rem] h-[40rem] bg-gradient-to-tr from-blue-500 via-blue-400 to-yellow-300"></div>
      </div>--> 

      <div class="absolute inset-0 -z-10">
        <div class="absolute -top-40 right-0 -z-10 opacity-20">
          <div
            class="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-blue-500 via-blue-400 to-yellow-300 blur-3xl"
            :style="{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }"
          />
        </div>
      </div>

      <div class="max-w-7xl mx-auto px-6">
        <h1 class="text-4xl sm:text-6xl font-extrabold tracking-tight text-white mb-6">
          Our Projects
        </h1>
        <p class="text-xl text-gray-300 leading-relaxed">
          Oillead Integrated Services Ventures Limited (OLS) delivers end-to-end engineering solutions across FEED, Detailed Engineering,
          Procurement, Fabrication, Installation, and Asset Integrity Management.
        </p>
      </div>
    </section>

   <!-- ================= PROJECT SECTION ================= -->
<section class="py-24 sm:py-24 bg-slate-900/40">
  <div class="max-w-7xl mx-auto px-6">

    <!-- Force equal height columns -->
    <div class="grid lg:grid-cols-2 gap-14 items-stretch">

      <!-- ================= CONTENT CARD ================= -->
      <div
        class="h-full rounded-3xl bg-slate-900/70 backdrop-blur-xl
               border border-slate-700/60 p-10
               hover:border-[#facc15]/60 transition relative overflow-hidden"
      >

        <!-- Subtle glow -->
        <div class="absolute inset-0 bg-gradient-to-br from-[#facc15]/5 via-transparent to-transparent pointer-events-none"></div>

        <div class="relative z-10">

          <!-- Accent line -->
          <div class="mb-10 h-px w-28 bg-gradient-to-r from-[#facc15] to-transparent"></div>

          <!-- Meta -->
          <div class="space-y-3 mb-10">
            <div class="flex gap-3 flex-wrap items-center">
              <span class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                PROJECT
              </span>
              <span class="text-2xl font-semibold text-white leading-snug">
                EAP GX-Inlet Gas Exchange Replacement Project
              </span>
            </div>

            <div class="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">CLIENT</span><br />
                Exxon Mobil
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">LOCATION</span><br />
                Nigeria
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">STATUS</span><br />
                Ongoing
              </p>
            </div>
          </div>

          <!-- Scope -->
          <div class="rounded-2xl bg-slate-800/50 p-6 border border-slate-700/50 space-y-8">

            <h3 class="text-xs font-bold uppercase tracking-[0.25em] text-[#facc15]">
              Scope of Work
            </h3>

            <!-- Engineering -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Engineering Design
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Perform all topside structural engineering checks and analysis
                    for installation of 110mT Inlet Gas Exchanger and deck extension.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Multi-discipline engineering deliverables.</span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Interface coordination and constructability reviews.</span>
                </li>
              </ul>
            </div>

            <!-- Construction -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Construction Engineering Support
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Temporary demolition and reuse of structural members,
                    excluding asbestos coverings.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Removal of pipe supports, roof beams, handrails, and
                    associated structures.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Fabrication, welding, rigging, and match-drilling works.
                  </span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <!-- ================= IMAGE COLUMN ================= -->
      <!-- Combined height == content card -->
      <div class="h-full grid grid-rows-2 gap-6">

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects7.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects8.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

      </div>

    </div>
    
  </div>
</section>

   <!-- ================= PROJECT SECTION ================= -->
<section class="py-24 sm:py-32 bg-slate-900/40">
  <div class="max-w-7xl mx-auto px-6">

    <!-- Force equal height columns -->
    <div class="grid lg:grid-cols-2 gap-14 items-stretch">

      <!-- ================= CONTENT CARD ================= -->
      <div
        class="h-full rounded-3xl bg-slate-900/70 backdrop-blur-xl
               border border-slate-700/60 p-10
               hover:border-[#facc15]/60 transition relative overflow-hidden"
      >

        <!-- Subtle glow -->
        <div class="absolute inset-0 bg-gradient-to-br from-[#facc15]/5 via-transparent to-transparent pointer-events-none"></div>

        <div class="relative z-10">

          <!-- Accent line -->
          <div class="mb-10 h-px w-28 bg-gradient-to-r from-[#facc15] to-transparent"></div>

          <!-- Meta -->
          <div class="space-y-3 mb-10">
            <div class="flex gap-3 flex-wrap items-center">
              <span class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                PROJECT
              </span>
              <span class="text-2xl font-semibold text-white leading-snug">
                AKPO / EGINA Laser scan, point cloud creation and 3D model delivery.
              </span>
            </div>

            <div class="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">CLIENT</span><br />
                Total Energies
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">LOCATION</span><br />
                Nigeria
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">STATUS</span><br />
                Ongoing
              </p>
            </div>
          </div>

          <!-- Scope -->
          <div class="rounded-2xl bg-slate-800/50 p-6 border border-slate-700/50 space-y-8">

            <h3 class="text-xs font-bold uppercase tracking-[0.25em] text-[#facc15]">
              Scope of Work
            </h3>

            <!-- Engineering -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Data capturing- As-built delivery:
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Offshore scanning and data capturing.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>E57 data processing.</span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Point cloud and 3D modelling.</span>
                </li>
              </ul>
            </div>

            <!-- Construction -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Key Activities:
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Site data capturing using 3D scanners / cameras
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Data alignment and processing to E3D to 5mm error margin
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Point cloud generation
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    E3D modelling and 2D deliverables
                  </span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <!-- ================= IMAGE COLUMN ================= -->
      <!-- Combined height == content card -->
      <div class="h-full grid grid-rows-2 gap-6">

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects9.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects10.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

      </div>

    </div>
    
  </div>
</section>

   <!-- ================= PROJECT SECTION ================= -->
<section class="py-24 sm:py-32 bg-slate-900/40">
  <div class="max-w-7xl mx-auto px-6">

    <!-- Force equal height columns -->
    <div class="grid lg:grid-cols-2 gap-14 items-stretch">

      <!-- ================= CONTENT CARD ================= -->
      <div
        class="h-full rounded-3xl bg-slate-900/70 backdrop-blur-xl
               border border-slate-700/60 p-10
               hover:border-[#facc15]/60 transition relative overflow-hidden"
      >

        <!-- Subtle glow -->
        <div class="absolute inset-0 bg-gradient-to-br from-[#facc15]/5 via-transparent to-transparent pointer-events-none"></div>

        <div class="relative z-10">

          <!-- Accent line -->
          <div class="mb-10 h-px w-28 bg-gradient-to-r from-[#facc15] to-transparent"></div>

          <!-- Meta -->
          <div class="space-y-3 mb-10">
            <div class="flex gap-3 flex-wrap items-center">
              <span class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                PROJECT
              </span>
              <span class="text-2xl font-semibold text-white leading-snug">
                Gas Supply to BUA Cement
              </span>
            </div>

            <div class="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">CLIENT</span><br />
                BUA Group
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">LOCATION</span><br />
                Nigeria
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">STATUS</span><br />
                Ongoing
              </p>
            </div>
          </div>

          <!-- Scope -->
          <div class="rounded-2xl bg-slate-800/50 p-6 border border-slate-700/50 space-y-8">

            <h3 class="text-xs font-bold uppercase tracking-[0.25em] text-[#facc15]">
              Scope of Work
            </h3>

            <!-- Engineering -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Engineering, Procurement and Construction
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    16”x 30km onshore pipeline and PRMS detailed design
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Procurement and Project management</span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>OEM support, FAT and delivery of Equipment.</span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Fabrication and Construction</span>
                </li>
              </ul>
            </div>

            <!-- Construction -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
               Key Activities:
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Hot tapping into Existing pipeline
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Pig launcher, valve stations and receiver
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Pipeline Construction and Pre- commissioning.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    PRMS installation and commissioning
                  </span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <!-- ================= IMAGE COLUMN ================= -->
      <!-- Combined height == content card -->
      <div class="h-full grid grid-rows-2 gap-6">

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects1.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects13.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

      </div>

    </div>
    
  </div>
</section>

   <!-- ================= PROJECT SECTION ================= -->
<section class="py-24 sm:py-32 bg-slate-900/40">
  <div class="max-w-7xl mx-auto px-6">

    <!-- Force equal height columns -->
    <div class="grid lg:grid-cols-2 gap-14 items-stretch">

      <!-- ================= CONTENT CARD ================= -->
      <div
        class="h-full rounded-3xl bg-slate-900/70 backdrop-blur-xl
               border border-slate-700/60 p-10
               hover:border-[#facc15]/60 transition relative overflow-hidden"
      >

        <!-- Subtle glow -->
        <div class="absolute inset-0 bg-gradient-to-br from-[#facc15]/5 via-transparent to-transparent pointer-events-none"></div>

        <div class="relative z-10">

          <!-- Accent line -->
          <div class="mb-10 h-px w-28 bg-gradient-to-r from-[#facc15] to-transparent"></div>

          <!-- Meta -->
          <div class="space-y-3 mb-10">
            <div class="flex gap-3 flex-wrap items-center">
              <span class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                PROJECT
              </span>
              <span class="text-2xl font-semibold text-white leading-snug">
                MPN – USARI ALTERNATE DEVELOPMENT PROJECT
              </span>
            </div>

            <div class="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">CLIENT</span><br />
                Total Energies
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">LOCATION</span><br />
                Nigeria
              </p>
              <p class="text-gray-400">
                <span class="font-bold text-[#facc15]">STATUS</span><br />
                Ongoing
              </p>
            </div>
          </div>

          <!-- Scope -->
          <div class="rounded-2xl bg-slate-800/50 p-6 border border-slate-700/50 space-y-8">

            <h3 class="text-xs font-bold uppercase tracking-[0.25em] text-[#facc15]">
              Scope of Work
            </h3>

            <!-- Engineering -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Seafastening Design and Transportation Analysis for Subsea Template (SST).
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Perform all topside structural engineering checks and analysis
                    for installation of 110mT Inlet Gas Exchanger and deck extension.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Multi-discipline engineering deliverables.</span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>Interface coordination and constructability reviews.</span>
                </li>
              </ul>
            </div>

            <!-- Construction -->
            <div>
              <h4 class="text-lg font-semibold text-[#facc15] mb-4">
                Construction Engineering Support
              </h4>

              <ul class="space-y-3 text-gray-300">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Key Activities:
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Provide extreme vessel motions and cargo accelerations which will be used as input for sea-fastening calculations.
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Validate the suitability of existing SST grillage for transportation
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Design new grillage and seafastening gussets for the SST
                  </span>
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  <span>
                    Provide transportation plan for the voyage.
                  </span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <!-- ================= IMAGE COLUMN ================= -->
      <!-- Combined height == content card -->
      <div class="h-full grid grid-rows-2 gap-6">

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects11.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

        <div class="relative rounded-3xl overflow-hidden group shadow-2xl">
          <img
            src="../assets/ourprojects12.png"
            alt="Project Image"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div class="absolute inset-0 ring-1 ring-[#facc15]/20 group-hover:ring-[#facc15]/40 transition"></div>
        </div>

      </div>

    </div>
    
  </div>
</section>


    <!-- ================= CTA ================= -->
    <section id="contact" class="relative py-28 bg-slate-900">
    

      <div class="max-w-2xl mx-auto text-center px-6">
        <h2 class="text-4xl font-bold text-white mb-6">
          Ready to Transform Your Project?
        </h2>
        <p class="text-xl text-gray-300 mb-10">
      Let's discuss how OLS can deliver engineering excellence for your next challenge.
        </p>

       <router-link to="/contact"
          class="inline-flex items-center gap-2 bg-yellow-400 font-bold py-4 px-10 rounded-xl text-black shadow-lg hover:bg-yellow-400 hover:scale-105 transition-all">
          Get in Touch →
        </router-link>
      </div>
    </section>

    <!-- ================= FOOTER ================= -->
    <footer class="bg-slate-950 border-t border-slate-800 py-10 text-center text-gray-400">
      © 2026 OILLEAD SERVICES. All rights reserved.
    </footer>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from "@headlessui/vue"


/* ================= SCROLL NAVBAR ================= */

const scrolled = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

   // your arrow scroll function
      function scrollFunction() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "block";
      } else {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "none";
      }
    }

    // your arrow scroll function
    function backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

onMounted(() => {
      // navabar scroll
      window.addEventListener("scroll", handleScroll);

      // your arrow onscroll
      window.onscroll = function () {
        scrollFunction();
      };
    });

    onUnmounted(() => {
      //navbar scroll
      window.removeEventListener("scroll", handleScroll);

      // cleanup arrow scroll
      window.onscroll = null;
    });
</script>

<style scoped>
.nav-link {
  font-size: 0.875rem;        /* text-sm */
  font-weight: 600;           /* font-semibold */
  letter-spacing: 0.05em;     /* tracking-wide */
  color: #ffffff;             /* text-white */
  cursor: pointer;            /* cursor-pointer */
  transition-property: color; /* transition-colors */
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

.nav-link:hover {
  color: #facc15; /* hover:text-yellow-400 */
}
</style>